import axios from "axios";
import { defaultValue, IApplication } from "../shared/model/application.model";
import { ICrudGetAllActionOnlyFilterCustom } from "../shared/model/crud-get-all-interface-only-filter";
import { FAILURE, REQUEST, SUCCESS } from "./actionType.util";

// TYPES
export const ACTION_TYPES = {
  FETCH_APPLICATION_LIST: "application/FETCH_APPLICATION_LIST",
  FETCH_APPLICATION: "application/FETCH_APPLICATION",
  RESET: "application/RESET",
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IApplication>,
  entity: defaultValue,
  totalItems: 0,
};

export type ApplicationState = Readonly<typeof initialState>;

// RECUCER

export const applicationReducer = (
  state: ApplicationState = initialState,
  action: any
) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_APPLICATION_LIST):
    case REQUEST(ACTION_TYPES.FETCH_APPLICATION):
      return {
        ...state,
        errorMessage: null,
        loading: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_APPLICATION_LIST):
    case FAILURE(ACTION_TYPES.FETCH_APPLICATION):
      return {
        ...state,
        loading: false,
        errorMessage: action?.payload?.response?.data?.message,
      };

    case SUCCESS(ACTION_TYPES.FETCH_APPLICATION_LIST):
      return {
        ...state,
        loading: false,
        errorMessage: null,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_APPLICATION):
      return {
        ...state,
        loading: false,
        errorMessage: null,
        entity: action.payload.data,
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

// ACTIONS
const apiUrl = "/api/ksds/portal-external/applications";

export const getEntities = (page, size, sort, filter) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}${filter ? filter : ''}`;
  return {
    type: ACTION_TYPES.FETCH_APPLICATION_LIST,
    payload: axios.get<IApplication>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};
export const getRelatedEntities: ICrudGetAllActionOnlyFilterCustom<IApplication> = filter => {
  const requestUrl = `${apiUrl}${filter ? filter : ''}`;
  return {
    type: ACTION_TYPES.FETCH_APPLICATION_LIST,
    payload: axios.get<IApplication>(`${requestUrl}`),
  };
};

export const getEntity = (id: number | string) => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_APPLICATION,
    payload: axios.get<IApplication>(requestUrl),
  };
};
export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
